<template>
  <div class="api-users-table">
    <b-table
      :data="data"
      :loading="loading"
      paginated
      backend-pagination
      :total="total"
      :per-page="perPage"
      @page-change="onPageChange"
      aria-next-label="Próxima Página"
      aria-previous-label="Página Anterior"
      aria-page-label="Página"
      aria-current-label="Página Atual"
    >
      <template slot-scope="props">
        <b-table-column field="id" label="#" numeric>{{
          props.row.id
        }}</b-table-column>

        <b-table-column field="name" label="Nome">{{
          props.row.user.name
        }}</b-table-column>

        <b-table-column field="email" label="E-mail">{{
          props.row.user.email
        }}</b-table-column>
        <b-table-column field="network" label="Rede">{{
          props.row.network.name
        }}</b-table-column>

        <b-table-column label="Opções">
          <button
            @click="edit(props.row.id)"
            v-app-button.icon-only
            v-tooltip.bottom="'Editar'"
          >
            <b-icon size="is-small" icon="pencil" />
          </button>
          <button
            @click="onClickDeleteApiUser(props.row.id)"
            v-app-button.icon-only
            v-tooltip.bottom="'Excluir'"
            color="danger"
          >
            <b-icon size="is-small" icon="delete" />
          </button>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>Nenhum registro encontrado.</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import ApiUserService from '@/services/api-user.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'api-users-table',
  mixins: [ToastMixin],
  data: () => {
    return {
      data: [],
      filters: {},
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      this.loading = true;

      ApiUserService.get({
        page: this.page,
        perPage: this.perPage,
        ...this.filters,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.data = data;
          this.total = total;
        })
        .catch(() => this.toastify('Erro ao carregar Usuários.', 'error'))
        .finally(() => (this.loading = false));
    },
    edit(id) {
      this.$router.push(`${id}/edit`);
    },
    onClickDeleteApiUser(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Usuário',
        message:
          'Tem certeza que deseja <b>excluir</b> este Usuário? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir Usuário',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteApiUser(id),
      });
    },
    deleteApiUser(id) {
      ApiUserService.delete(id)
        .then(() => {
          this.toastify('Usuário excluído com sucesso.');
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Usuário.',
            'error'
          );
        });
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>
